import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import SimpleLeftArrowIconSvg from './SimpleLeftArrowIconSvg'

const SimpleLeftArrowIcon = (props: IconProps): ReactElement => (
    <Icon component={SimpleLeftArrowIconSvg} {...props} />
)

export default SimpleLeftArrowIcon
